// extracted by mini-css-extract-plugin
export default {"blueButton":"button_blueButton__UH0j2"};